import RequirementsFormContainer from './requirements_form_container';

const RequirementsForm = RequirementsFormContainer;
export default RequirementsForm;
